import * as api from '@sophocles/api/siteGroupSettings';
import { createSettingsFeature } from '@sophocles/features/_settings/createSettingsFeature';

const feature = createSettingsFeature({
  name: 'siteGroupSettings',
  idKey: 'siteGroupId',
  api: { fetch: api.fetchSiteGroupSettings, patch: api.patchSiteGroupSettings },
});

// Top-level + per-section hooks.
export const useSiteGroupSettings = feature.useSettings;

export default feature.reducer;
